/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable react/prop-types */

import { Button } from '@material-ui/core'
import React from 'react'
import '../buttonstyles.scss'
var classNames = require('classnames')

export const FlatOutlinedButton = ({
  onClick,
  children,
  style = {},
  gray = false,
  disabled = false,
  fullWidth = false,
  unFilledHover = false,
  textBold = false,
}) => {
  return (
    <Button
      onClick={onClick}
      style={{ color: 'white', ...style }}
      className={classNames(
        { 'gray-button': gray },
        'outlined button flat',
        { 'full-width': fullWidth },
        { 'unfilled-bold-button': unFilledHover },
        { bolder: textBold }
      )}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
